import view from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		replace:                    true,
		scope:                      true,
		controller: /* @ngInject */ ($scope, STATUSES, $http, DataTablesService, moment, ReportsService, Reports) => {
			$scope.start          = $scope.parameters.start;
			$scope.end            = $scope.parameters.end;
			$scope.supportWorkers = [
				'*',
			];

			const rosterPeriod = ReportsService.rosterPeriod();

			if (!$scope.start) {
				$scope.start = rosterPeriod.start;
			}

			if (!$scope.end) {
				$scope.end = rosterPeriod.end;
			}

			$scope.status = STATUSES.UNLOADED;
			$scope.moment = moment;

			$scope.dataTable = null;

			$scope.data  = [];
			$scope.error = null;

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;

				$scope.data  = [];
				$scope.error = null;

				return Reports.one($scope.reportId)
				              .one('execute')
				              .get({
					              start:             $scope.start.format(),
					              end:               $scope.end.format(),
					              'support-workers': $scope.supportWorkers.join(','),
				              })
				              .then((data) => {
					              $scope.dataTable = DataTablesService.configure({
						              id:    $scope.reportId,
						              title: 'Support Worker Roster Report',
					              }, {
						              order: [
							              [
								              6,
								              'asc',
							              ],
							              [
								              0,
								              'asc',
							              ],
							              [
								              1,
								              'asc',
							              ],
						              ],
					              });

					              $scope.data  = data.map((visit) => {
						              return {
							              ...visit,
							              'Duration': parseInt(visit['Duration']),
							              'KMs':      parseFloat(visit['KMs']),
							              'Travel':   parseFloat(visit['Travel']),
						              };
					              });
					              $scope.error = null;

					              $scope.status = STATUSES.LOADED;

					              return data;
				              })
				              .catch((error) => {
					              $scope.data  = [];
					              $scope.error = error;

					              $scope.status = STATUSES.ERRORED;
				              });
			};

			$scope.refresh();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/reports/BF4DBCEC-4392-4E11-A5CA-90B1B39F1E26/index.js